import { render, staticRenderFns } from "./make-payment-address.vue?vue&type=template&id=189d00a4&scoped=true&"
import script from "./make-payment-address.vue?vue&type=script&lang=js&"
export * from "./make-payment-address.vue?vue&type=script&lang=js&"
import style0 from "./make-payment-address.vue?vue&type=style&index=0&id=189d00a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d00a4",
  null
  
)

export default component.exports